// eslint-disable-next-line camelcase
// export const static_pdf_URL =
//   process.env.VUE_APP_MODE === "prod"
//     ? `https://static-h5.eceibs.net/pdf/1`
//     : "http://static-h5.eceibs.net/pdf/1";

export const static_pdf_URL = `${location.protocol}//static-h5.eceibs.net/pdf/1`
